import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=8a021cde&scoped=true&"
import script from "./Delivery.vue?vue&type=script&lang=ts&"
export * from "./Delivery.vue?vue&type=script&lang=ts&"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=8a021cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a021cde",
  null
  
)

export default component.exports